import { render, staticRenderFns } from "./wr_ybm_report.vue?vue&type=template&id=32928aa1&scoped=true"
import script from "./wr_ybm_report.vue?vue&type=script&lang=js"
export * from "./wr_ybm_report.vue?vue&type=script&lang=js"
import style0 from "./wr_ybm_report.vue?vue&type=style&index=0&id=32928aa1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32928aa1",
  null
  
)

export default component.exports